<section class="carousel-wrapper" #carouselWrapper>
  <ul class="carousel-inner" #carousel [ngStyle]="carouselInnerStyle">
    @for (item of items; track item) {
      <li class="carousel-item" (click)="stopTimeInterval()" [ngStyle]="carouselInnerStyle">
        <ng-container [ngTemplateOutlet]="item.tpl"></ng-container>
      </li>
    }
  </ul>
</section>
@if (showControls && items.length > 1) {
  <div class="carousel-controls">
    <button
      (click)="prev(); stopTimeInterval()"
      class="secondary icon-chevron-left"
      [disabled]="currentSlide === 0"
      [style.background-color]="controlColor"></button>
    <button
      (click)="next(); stopTimeInterval()"
      class="secondary icon-chevron-right"
      [disabled]="currentSlide === items.length - 1"
      [style.background-color]="controlColor"></button>
  </div>
}
